
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import useTranslation from 'next-translate/useTranslation'
import Link from 'next/link'
import Trans from 'next-translate/Trans'
import NextLink from 'next/link'
import { ButtonLink } from '@components/ui/ButtonLink'
import { LayoutWithHeader } from '@components/common/Layout/LayoutWithoutHeader'
import { Logo } from '@components/ui'
import { CheckoutFooter } from '@components/checkout/CheckoutFooter'

export default function Error() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-row flex-wrap	 content-between w-full min-h-screen">
      <div className="w-full">
        <div className="h-fit w-fit pt-9 mx-content-margin-mobile sm:mx-content-margin-desktop">
          <Link href="/" aria-label="Logo">
            <Logo />
          </Link>
        </div>
      </div>
      <div className="flex w-full flex-col items-center justify-center text-center">
        <>
          <h2 className="mb-6 text-xl font-bold">
            {t('checkout:error_payment_title')}
          </h2>
          <p className="mb-11 w-80">
            <Trans
              i18nKey={'checkout:error_payment_description'}
              components={[<NextLink href="/" className="underline" key={0} />]}
            />
          </p>
          <ButtonLink
            className="w-64 max-w-full mx-auto"
            href="/checkout"
            text={t('checkout:error_payment_button')}
          />
        </>
      </div>
      <div className="w-full">
        <CheckoutFooter className="mt-8 w-full" />
      </div>
    </div>
  )
}

Error.Layout = LayoutWithHeader


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/checkout/error',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  